"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.projectItemShape = exports["default"] = void 0;

require("core-js/modules/es6.function.bind.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactComponents = require("@ucloud-fe/react-components");

var _localeConsumerDecorator = require("../../utils/localeConsumerDecorator");

var _Projects = _interopRequireDefault(require("./Projects"));

var _zh_CN = _interopRequireDefault(require("./locale/zh_CN"));

var _style = require("./style");

var _Down = _interopRequireDefault(require("@ucloud/ucloud-icons/dist/uc-directional/svgr/Down"));

var _Up = _interopRequireDefault(require("@ucloud/ucloud-icons/dist/uc-directional/svgr/Up"));

var _this = void 0;

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var projectItemShape = {
  ProjectId: _propTypes["default"].string.isRequired,
  ProjectName: _propTypes["default"].string.isRequired,
  CreateTime: _propTypes["default"].number,
  IsDefault: _propTypes["default"]["boolean"]
};
exports.projectItemShape = projectItemShape;

var ProjectSelect = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(ProjectSelect, _PureComponent);

  var _super = _createSuper(ProjectSelect);

  function ProjectSelect(props) {
    (0, _classCallCheck2["default"])(this, ProjectSelect);
    return _super.call(this, props);
  }

  (0, _createClass2["default"])(ProjectSelect, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          locale = _this$props.locale,
          items = _this$props.items,
          currentProject = _this$props.currentProject,
          visible = _this$props.visible,
          onDefaultChange = _this$props.onDefaultChange,
          onProjectChange = _this$props.onProjectChange,
          onVisibleChange = _this$props.onVisibleChange,
          bottom = _this$props.bottom,
          _this$props$textStyle = _this$props.textStyle,
          textStyle = _this$props$textStyle === void 0 ? {} : _this$props$textStyle;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactComponents.Popover, {
        popup: /*#__PURE__*/_react["default"].createElement(_Projects["default"], {
          locale: locale,
          currentProject: currentProject,
          onDefaultChange: onDefaultChange,
          items: items,
          onProjectChange: onProjectChange,
          bottom: bottom
        }),
        visible: visible,
        onVisibleChange: onVisibleChange,
        trigger: ["click"]
      }, /*#__PURE__*/_react["default"].createElement(_style.CurrentProject, {
        textStyle: textStyle
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "".concat(_style.prefixCls, "-current"),
        title: currentProject === null || currentProject === void 0 ? void 0 : currentProject.ProjectName
      }, currentProject === null || currentProject === void 0 ? void 0 : currentProject.ProjectName), visible ? /*#__PURE__*/_react["default"].createElement(_Up["default"], null) : /*#__PURE__*/_react["default"].createElement(_Down["default"], null))));
    }
  }]);
  return ProjectSelect;
}(_react.PureComponent);

ProjectSelect.propTypes = {
  /**
   * 项目列表
   */
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape(projectItemShape)),

  /**
   * 是否展开下拉列表项
   */
  visible: _propTypes["default"].bool,

  /**
   * 选中的 project
   */
  currentProject: _propTypes["default"].shape(projectItemShape),

  /**
   * visible 变化的回调函数
   */
  onVisibleChange: _propTypes["default"].func,

  /**
   * 设置默认项函数
   */
  onDefaultChange: _propTypes["default"].func,

  /**
   * 选中变化时的回调
   */
  onProjectChange: _propTypes["default"].func,

  /**
   * 底部的操作项，例如：跳转到账号管理函数
   */
  bottom: _propTypes["default"].node,

  /**
   * 字体相关样式
   */
  textStyle: _propTypes["default"].object,

  /** @ignore */
  locale: _propTypes["default"].object
};
ProjectSelect.defaultProps = {
  items: [],
  currentProject: {},
  visible: false,
  textStyle: {},
  onDefaultChange: function onDefaultChange() {
    (0, _newArrowCheck2["default"])(this, _this);
  }.bind(void 0),
  onProjectChange: function onProjectChange() {
    (0, _newArrowCheck2["default"])(this, _this);
  }.bind(void 0),
  onVisibleChange: function onVisibleChange() {
    (0, _newArrowCheck2["default"])(this, _this);
  }.bind(void 0)
};

var _default = (0, _localeConsumerDecorator.localeConsumerDecorator)({
  defaultLocale: _zh_CN["default"],
  localeName: "UI_ProjectSelect"
})(ProjectSelect);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/ProjectSelect/ProjectSelect.js
// module id = 1721
// module chunks = 6 7 17 18